import CalendarBlockCheckbox from "./CalendarBlockCheckbox";
import CalendarBlockTime from "./CalendarBlockTime";
import CalendarBlockTitle from "./CalendarBlockTitle";
import CalendarBlockIconSection from "./CalendarBlockIconSection";
import { inProgressSpaceListState } from "../../../recoil/spaces/inProgressSpaceListState";
import { useRecoilValue } from "recoil";
import { getSpaceColor } from "../../../services/space/space.service";
import { DEFAULT_SPACE_COLOR } from "../../../constants/space";
import CalendarBlockContainer from "./CalendarBlockContainer";

import { useEffect, useState } from "react";
import { BlockType } from "../../../types/block/type";
import { ItemStatus } from "../../../types/block/enum";

import { CALENDAR_VIEW_TYPE, DefaultDurationValueMap } from "../../../types/account/enum";
import { usePreference } from "../../../hooks/preference/usePreference";
import { DefaultPreferenceOptions } from "../../../constants/userPreference";
interface CalendarBlockProps {
  data: BlockType;
}

const CalendarBlock = ({ data }: CalendarBlockProps) => {
  /**
   * 블록 UI만을 위한 컴포넌트
   *
   * width, height는 드래그 용으로 존재(이때에만 너비 높이 조절 필요, 나머지는 자동 조절됨)
   * blockSize는 15분 블럭과 나머지 구별하는 용도
   * - small : 15분 || allday
   * - large: 15분 이상
   *
   */
  const { preference: userPreference } = usePreference();

  const calendarView =
    userPreference?.calendarViewType ?? DefaultPreferenceOptions.calendarViewType;
  const defaultDuration =
    DefaultDurationValueMap[
      userPreference?.defaultDuration ?? DefaultPreferenceOptions.defaultDuration
    ];

  const projectList = useRecoilValue(inProgressSpaceListState);
  const baseColor = data.spaceId ? getSpaceColor(projectList, data.spaceId) : DEFAULT_SPACE_COLOR;

  const [finalWidth, setFinalWidth] = useState(0);
  const [itemHeight, setItemHeight] = useState(0);
  const [blockSize, setBlockSize] = useState<"small" | "large">("small");

  useEffect(() => {
    const isMonthView = calendarView === CALENDAR_VIEW_TYPE.MONTH;
    const container = isMonthView
      ? document.querySelector(".rbc-day-bg")
      : document.querySelector(".rbc-events-container");

    if (container) {
      setFinalWidth(container.clientWidth);
    }

    const heightInPixels = (Number(defaultDuration) / 15) * 20;
    setItemHeight(heightInPixels);
    setBlockSize(heightInPixels <= 20 ? "small" : "large");

    if (heightInPixels <= 20) {
      setBlockSize("small");
    }

    setItemHeight(heightInPixels);
  }, [defaultDuration]);

  return (
    <CalendarBlockContainer
      width={finalWidth}
      height={itemHeight}
      blockSize={blockSize}
      projectColor={baseColor ?? "#ababad"}
      isCompleted={data.itemStatus === ItemStatus.COMPLETED}
    >
      <div className="flex gap-1.5 justify-between items-flex-start w-full">
        <CalendarBlockCheckbox baseColor={baseColor ?? DEFAULT_SPACE_COLOR} />
        <div className="flex flex-col flex-1 w-full line-clamp-1">
          <CalendarBlockTitle
            title={data.title}
            blockType={data.blockType}
          />
          {blockSize !== "small" && <CalendarBlockTime />}
        </div>
        <CalendarBlockIconSection
          priority={data?.priority}
          linkData={data?.linkData ?? []}
          note={data?.note}
        />
      </div>
    </CalendarBlockContainer>
  );
};

export default CalendarBlock;
